<h5 class="text-primary mb-3">Lights</h5>
@if (lights()) {
  <div class="row">
    @for (light of lights(); track light) {
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <era-light-ui [light]="light"></era-light-ui>
      </div>
    }
  </div>
} @else {
  No lights are available for this room.
}